import React, {useState, memo, useEffect} from "react";
import Row from './Row'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';

import './index.css'

const SumoTableFilter = ({ list }) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <div className="sumo-table-sub">{ list.objReply.status  === '200' ?
            (
                <>
                    <TableContainer component={Paper}>
                        <Table aria-label="collapsible table">
                            <TableHead>
                                <TableRow>
                                    <TableCell />
                                    <TableCell align="left">Host</TableCell>
                                    <TableCell align="left">name</TableCell>
                                    <TableCell align="left">category</TableCell>
                                    <TableCell align="left">timeStamp</TableCell>
                                    <TableCell align="left">instance</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list.objReply.dataList
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => <Row key={index} row={row}/>)
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        className="table-pagination"
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={list.objReply.dataList.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </>
            ) : (
                <div>Error message</div>
            )
        }
        </div>
    )
}

export default memo(SumoTableFilter);

